<div class='text-center'>

  <div class='checkmark centered'></div>
  <h3>Thanks for your interest in Starry!</h3>

  <p>
    We’ll send updates if Starry becomes available in your area — plus other exciting news about our service.
  </p>
</div>
